import { Link } from 'react-router-dom';
import classNames from 'classnames';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';

import ImageTranslator from '~/components/Image/ImageTranslator';
import NewTabOpener from '~/components/NewTabOpener';

import euLogoDe from '~/assets/images/eu-logo-de.png';
import euLogoEn from '~/assets/images/eu-logo-en.png';
import logo from '~/assets/images/game@3x.png';

import style from './GameDeSection.module.scss';

const euLogo = {
  en: euLogoEn,
  de: euLogoDe,
};

const GameDeSection = ({ className }) => (
  <div className={classNames(style.section, className)}>
    <Link to="/efre-projektfoerderung">
      <ImageTranslator
        alt="Eu logo"
        src={euLogo}
      />
    </Link>
    <NewTabOpener href={I18n.t('game_de_url')}>
      <img
        alt=""
        src={logo}
      />
    </NewTabOpener>
  </div>
);

GameDeSection.propTypes = {
  className: PropTypes.string,
  language: PropTypes.string,
};

export default GameDeSection;
